var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessageBubble(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 34.1116C59.2404 22.4624 51.3416 12.5031 40.1714 9.11076C29.0013 5.71839 16.8981 9.60302 9.78858 18.8624C2.67911 28.1217 2.05159 40.8176 8.21333 50.7329L0 67.9996L17.256 59.7756C20.4918 61.7936 24.1064 63.1276 27.8773 63.6956",
    fill: "#F2FCEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66 28.1116C65.2404 16.4624 57.3416 6.50314 46.1714 3.11076C35.0013 -0.281611 22.8981 3.60302 15.7886 12.8624C8.67911 22.1217 8.05159 34.8176 14.2133 44.7329L6 61.9996L23.256 53.7756C26.4918 55.7936 30.1064 57.1276 33.8773 57.6956",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66 28.1116C65.2404 16.4624 57.3416 6.50314 46.1714 3.11076C35.0013 -0.281611 22.8981 3.60302 15.7886 12.8624C8.67911 22.1217 8.05159 34.8176 14.2133 44.7329L6 61.9996L23.256 53.7756C26.4918 55.7936 30.1064 57.1276 33.8773 57.6956",
    stroke: "#5C5C5C",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42 46C42 43.7909 43.7909 42 46 42H62C64.2091 42 66 43.7909 66 46V58C66 60.2091 64.2091 62 62 62H46C43.7909 62 42 60.2091 42 58V46Z",
    stroke: "#228800",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54 30V30C49.5817 30 46 33.5817 46 38V42H62V38C62 33.5817 58.4183 30 54 30Z",
    stroke: "#228800",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54 51.0771C53.4477 51.0771 53 51.5249 53 52.0771C53 52.6294 53.4477 53.0771 54 53.0771C54.5523 53.0771 55 52.6294 55 52.0771C55 51.5249 54.5523 51.0771 54 51.0771",
    stroke: "#5C5C5C",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageBubble);
export default __webpack_public_path__ + "assets/media/messageBubble.a3850ab9281537a3380b342e1c078dc0.svg";
export { ForwardRef as ReactComponent };